import React from 'react';
import { IconProps } from 'types';

const Logo = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="240"
      height="22"
      viewBox="0 0 405.9 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style type="text/css">
          {`.st0{enable-background:new;}
          .st1{fill:#FFFFFF;}`}
        </style>
      </defs>
      <g className="st0">
        <path
          className="st1"
          d="M23.4,22.5c0,3.9-3.7,6.6-10.6,6.6c-5,0-9-1.4-12-3.9L3.4,22c2.4,2.2,5.5,3.2,9.5,3.2c4,0,6-0.8,6-2.4
            s-2-2.1-6.5-2.5C6.8,20,1.6,18.7,1.6,14.5C1.6,10.4,6,8.2,12,8.2c4.3,0,8,1.1,10.5,3L20,14.3c-2.2-1.7-4.8-2.3-8-2.4
            c-2.7,0-5.9,0.4-5.9,2.2c0,1.7,2.8,1.8,6.7,2.2C19,16.9,23.4,18.2,23.4,22.5z"
        />
        <path
          className="st1"
          d="M57.9,8.8l-7.2,19.6h-4.6L41,13.6l-5.2,14.8h-4.5L24.1,8.8h4.7l4.8,14.5l5.2-14.5h4.3l5.2,14.5l4.8-14.5H57.9z
            "
        />
        <path
          className="st1"
          d="M75.7,24.3H63.8l-2.1,4.1H57L67.3,8.8h4.9l10.4,19.6h-4.8L75.7,24.3z M73.8,20.6l-4.1-8l-4.1,8H73.8z"
        />
        <path
          className="st1"
          d="M101.6,12.7H93v15.7h-4.5V12.7h-8.5V8.8h21.6V12.7z"
        />
        <path
          className="st1"
          d="M129.1,28.4l-1.5-1.1c-1.8,1.1-4.2,1.7-7,1.7c-5.9,0-10.3-2.9-10.3-6.6c0-2.2,1.5-4.1,4.1-5.1
            c-1.1-1-1.7-2.1-1.7-3.5c0-3.1,3-5.5,7.8-5.5c5.1,0,7.8,2.4,9.3,5.1l-3.7,1.5c-1.5-2.5-3.2-3.4-5.5-3.4c-2.2,0-3.6,0.8-3.6,2.3
            c0,1.3,1.1,2,3.3,3.7l7.1,5.4c0.6-1,1-2.2,1.1-3.8h4c-0.1,2.3-0.8,4.4-2.1,6l4.4,3.4H129.1z M124.7,25.1l-8.1-6.1
            c-1.2,0.8-1.7,1.8-1.7,3c0,2.5,2.7,3.8,6,3.8C122.3,25.8,123.6,25.6,124.7,25.1z"
        />
        <path
          className="st1"
          d="M160.1,24.3h-11.8l-2.1,4.1h-4.8l10.4-19.6h4.9L167,28.4h-4.8L160.1,24.3z M158.2,20.6l-4.1-8l-4.1,8H158.2z"
        />
        <path
          className="st1"
          d="M191.5,15.5c0,4.3-3.4,6.6-8.4,6.6h-8.9v6.3h-4.5V8.8h13.4C188.2,8.8,191.5,11.2,191.5,15.5z M187,15.5
            c0-2.2-1.7-2.9-4.2-2.9h-8.6v5.8h8.6C185.3,18.4,187,17.7,187,15.5z"
        />
        <path
          className="st1"
          d="M212.5,22l4.1,2c-1.8,2.8-5.6,5-10.8,5c-7.4,0-12.2-3.9-12.2-10.4c0-6.5,4.8-10.4,12.3-10.4
            c4.9,0,8.7,2.3,10.5,5l-4.1,2c-1.4-2.2-3.5-3.2-6.4-3.2c-4.6,0-7.7,2.2-7.7,6.6c0,4.3,3.1,6.6,7.7,6.6
            C208.9,25.2,211.1,24.2,212.5,22z"
        />
        <path
          className="st1"
          d="M229.2,8.8l7.4,15.1l7.4-15.1h4.8l-9.9,19.6h-4.7l-9.9-19.6H229.2z"
        />
        <path
          className="st1"
          d="M271.6,24.7v3.8h-20.2V8.8h19.9v3.8h-15.5v4h12.9v3.8h-12.9v4.3H271.6z"
        />
        <path
          className="st1"
          d="M297.8,8.8v19.6h-4.5v-8h-13.4v8h-4.5V8.8h4.5v7.7h13.4V8.8H297.8z"
        />
        <path className="st1" d="M303,28.4V8.8h4.5v19.6H303z" />
        <path
          className="st1"
          d="M330.3,22l4.1,2c-1.8,2.8-5.6,5-10.8,5c-7.4,0-12.2-3.9-12.2-10.4c0-6.5,4.8-10.4,12.3-10.4
            c4.9,0,8.7,2.3,10.5,5l-4.1,2c-1.4-2.2-3.5-3.2-6.4-3.2c-4.6,0-7.7,2.2-7.7,6.6c0,4.3,3.1,6.6,7.7,6.6
            C326.7,25.2,328.9,24.2,330.3,22z"
        />
        <path className="st1" d="M356.1,24.6v3.9h-18.3V8.8h4.5v15.7H356.1z" />
        <path
          className="st1"
          d="M379.5,24.7v3.8h-20.2V8.8h19.9v3.8h-15.5v4h12.9v3.8h-12.9v4.3H379.5z"
        />
        <path
          className="st1"
          d="M404.1,22.5c0,3.9-3.7,6.6-10.6,6.6c-5,0-9-1.4-12-3.9l2.6-3.1c2.4,2.2,5.5,3.2,9.5,3.2c4,0,6-0.8,6-2.4
            s-2-2.1-6.5-2.5c-5.6-0.5-10.8-1.7-10.8-5.9c0-4.1,4.4-6.3,10.4-6.3c4.3,0,8,1.1,10.5,3l-2.5,3.1c-2.2-1.7-4.8-2.3-8-2.4
            c-2.7,0-5.9,0.4-5.9,2.2c0,1.7,2.8,1.8,6.7,2.2C399.7,16.9,404.1,18.2,404.1,22.5z"
        />
      </g>
    </svg>
  );
};

export default Logo;
